export default "__VITE_ASSET__vEHaFpdx__"